<template>
  <div class="investors-gm">
    <p class="indent">Общото събрание е основната възможност и идеалното място за акционерите, да се срещнат и обменят
      мнения за бизнеса на Алкомет с директорите и ръководството.</p>
    <div class="gm-table-wrapper">
      <table class="gm-table">
        <thead>
        <tr class="gm-table-row">
          <td class="gm-table-main-title" colspan="2"><span>Общи събрания и отчети</span></td>
        </tr>
        </thead>
        <tbody>


        <tr class="gm-table-row">
          <td class="gm-table-date">14.06.2024 </td>
          <td class="gm-table-title">Общо събрание на акционерите на Алкомет АД, насрочено за 14.06.2024



            <br><a href="/static/files/financial_statements/2024/Протокол-ОСА-1.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол от Общо Събрание на акционерите на Алкомет АД, провело се на 14.06.2024</span></a>

            <br><a href="/static/files/general_meetings/21052024/Дневен-ред-ОСА.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Дневен ред на ОСА</span></a>

            <br><a href="/static/files/general_meetings/21052024/Модел-за-пълномощно-ОСА.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Пълномощно образец за ОСА</span></a>

            <br><a href="/static/files/general_meetings/21052024/Одитиран-Индиивидуален-финансов-отчет-Алкомет-АД-за-2023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен одитиран индивидуален финансов отчет на Алкомет АД за 2023</span></a>

            <br><a href="/static/files/general_meetings/21052024/Одитиран%20Консолидиран%20финансов%20отчет%20Алкомет%20АД%20за%202023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен одитиран консолидиран финансов отчет на Алкомет АД за 2023</span></a>

            <br><a href="/static/files/general_meetings/21052024/Отчет%20на%20Одитен%20Комитет%20за%202023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Отчет на Одитен комитет за 2023</span></a>

            <br><a href="/static/files/general_meetings/21052024/Отчет-на-Директор-за-връзка-с-инвеститорите-за-2023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Отчет на Директора за връзка с инвеститорите за 2023</span></a>

            <br><a href="/static/files/general_meetings/21052024/Покана-ОСА.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Покана за свикване на ОСА</span></a>

            <br><a href="/static/files/general_meetings/21052024/Уведомление-провеждане-на-ОСА-на-14.06.24.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Уведомление относно публикуване на материали за ОСА</span></a>

          </td>
        </tr>


        <tr class="gm-table-row">
          <td class="gm-table-date">15.06.2023 </td>
          <td class="gm-table-title">Общо събрание на акционерите на Алкомет АД, насрочено за 15.06.2023

            <br><a href="/static/files/general_meetings/2023/protocol-OSA.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол от Общо Събрание на акционерите на Алкомет АД, провело се на 15.06.2023</span></a>

            <br><a href="/static/files/general_meetings/2023/protocol-nachin-na-razpredeljana-na-divident.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол от заседание на УС на Алкомет АД, определящ начина за разпределяне на дивидентите за 2022 г.</span></a>

            <br><a href="/static/files/general_meetings/2023/дневен-ред-на-ОСА-на-15.05.2023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Дневен ред на ОСА на 15.05.2023</span></a>

            <br><a href="/static/files/general_meetings/2023/покана-за-свикване-на-ОСА-на-15.06.2023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Покана за свикване на ОСА на 15.06.2023</span></a>

            <br><a href="/static/files/general_meetings/2023/уведомление-относно-публикуване-на-материали-за-ОСА-на-15.06.2023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Уведомление относно публикуване на материали за ОСА на 15.06.2023</span></a>

            <br><a href="/static/files/general_meetings/2023/годишен-одитиран-индивидуален-финансов-отчет-2022.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен одитиран индивидуален финансов отчет на Алкомет АД за 2022</span></a>

            <br><a href="/static/files/general_meetings/2023/годишен-одитиран-консолидиран-финансов-отчет-на-Алкомет-АД-за-2022.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен одитиран консолидиран финансов отчет на Алкомет АД за 2022</span></a>

            <br><a href="/static/files/general_meetings/2023/пълномощно-образец-за-ОСА-на-15.06.2023.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Пълномощно образец за ОСА на 15.06.2023</span></a>


            <br><a href="/static/files/general_meetings/2023/отчет-на-одитен-комитет-за-2022.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Отчет на Одитен комитет за 2022</span></a>

            <br><a href="/static/files/general_meetings/2023/отчет-на-Директора-за-връзка-с-инвеститорите-за-2022.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Отчет на Директора за връзка с инвеститорите за 2022</span></a>
          </td>
        </tr>

        <tr class="gm-table-row">
          <td class="gm-table-date">15.06.2022 </td>
          <td class="gm-table-title">Общо събрание на акционерите на Алкомет АД, 15.06.2022
            <br><a href="/static/files/general_meetings/protocol-osa-15.06.2022.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол от Общо събрание на акционерите на Алкомет АД, провело се на 15.06.2022</span></a>

            <br><a href="/static/files/general_meetings/09052022/Декларации-чл-116а-т-2-о-ЗППЦК-на-ТЗ-на-предложените-за-независими-членове-на-НС.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Декларации чл. 116а т.2 от ЗППЦК на ТЗ на предложените за независими членове на НС</span></a>

            <br><a href="/static/files/general_meetings/09052022/Декларации-чл-237-на-ТЗ-на-предложените-за-членове-на-НС.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Декларации чл 237 на ТЗ на предложените за членове на НС</span></a>

            <br><a href="/static/files/general_meetings/09052022/Дневен-ред.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Дневен ред</span></a>

            <br><a href="/static/files/general_meetings/09052022/Индивидуален-одитиран-финансов-отчет-Алкомет-АД-2021.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Индивидуален одитиран финансов отчет Алкомет АД 2021</span></a>

            <br><a href="/static/files/general_meetings/09052022/Консолидиран-одитиран-финансов-отчет-Алкомет-АД-2021%20.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Консолидиран одитиран финансов отчет Алкомет АД 2021</span></a>


            <br><a href="/static/files/general_meetings/09052022/Модел-пълномощно-за-ОСА.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Модел пълномощно за ОСА</span></a>

            <br><a href="/static/files/general_meetings/09052022/Отчет-на-ДВИ-за-2021.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Отчет на ДВИ за 2021</span></a>

            <br><a href="/static/files/general_meetings/09052022/Отчет-Одитен-комитет-за-2021.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Отчет Одитен комитет за 2021</span></a>


            <br><a href="/static/files/general_meetings/09052022/Покана-за-ОСА.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Покана за ОСА</span></a>

            <br><a href="/static/files/general_meetings/09052022/Свидетелства-зa-съдимост-на-предложените-за-членове-на-НС.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Свидетелства зa съдимост на предложените за членове на НС</span></a>

            <br><a href="/static/files/general_meetings/09052022/Устав-Алкомет-АД.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Устав</span></a>



          </td>
        </tr>



        <tr class="gm-table-row">
            <td class="gm-table-date">15.12.2021</td>
            <td class="gm-table-title">Общо събрание на акционерите на Алкомет АД, 15.12.2021

                <br><a href="/static/files/general_meetings/15122021/protocol-no-eng.pdf" target="_blank"
                       class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                        class="gm-table-link-text">Протокол от извънредното общо събрание на акционерите</span></a>

                <br><a href="/static/files/general_meetings/15122021/dneven-red.pdf" target="_blank"
                       class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                        class="gm-table-link-text">Избор на независим регистриран одитор за финансовата 2021</span></a>

                <br><a href="/static/files/general_meetings/15122021/poa-izvanredno-osa-2021.pdf" target="_blank"
                       class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                        class="gm-table-link-text">Пълномощно - образец</span></a>

                <br><a href="/static/files/general_meetings/15122021/pokana.pdf" target="_blank"
                       class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                        class="gm-table-link-text">Покана за свикване на извънредно общо събрание на акционерите</span></a>

                <br><a href="/static/files/general_meetings/15122021/reshenie-ok.pdf" target="_blank"
                       class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                        class="gm-table-link-text">Протокол от заседанието на одитния комитет на Алкомет АД</span></a>


            </td>
        </tr>


        <tr class="gm-table-row">
          <td class="gm-table-date">09.06.2021</td>
          <td class="gm-table-title">Общо събрание на акционерите на "Алкомет" АД, което ще се състои на 09.06.2021 г.

              <br><a href="/static/files/financial_statements/09062021/protocol-10062021.pdf" target="_blank"
                     class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                      class="gm-table-link-text">Протокол от Общо Събрание на акционерите</span></a>

            <br><a href="/static/files/financial_statements/09062021/уведомление-относно-публикуване-на-материали-за-оса.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">Уведомление относно публикуване на материали за ОСА на 09.06.2021 г.</span></a>

            <br><a href="/static/files/financial_statements/09062021/agenda.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">Дневен ред</span></a>

            <br><a href="/static/files/financial_statements/09062021/Alcomet AD_Audit-report_2020_BG_Consolidated_29.04.2021-signed.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">Доклад относно одита на консолидирания финансов отчет</span></a>

            <br><a href="/static/files/financial_statements/09062021/Alcomet AD-Separate-Annual-Activity-Report-signed.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">ГОДИШЕН ИНДИВИДУАЛЕН ДОКЛАД ЗА ДЕЙНОСТТА
на Алкомет АД за 2020 година</span></a>

            <br><a href="/static/files/financial_statements/09062021/Alcomet_Audit-report 2020_BG_Separate-31.03.2021_Signed.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">Доклад относно одита на индивидуалния финансов отчет</span></a>

            <br><a href="/static/files/financial_statements/09062021/Alcomet-AD-Consolidated-Annual-Activity-Report-2020-FINAL-signed.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">ГОДИШЕН КОНСОЛИДИРАН ДОКЛАД ЗА ДЕЙНОСТТА
на Алкомет АД за 2020 година</span></a>

            <br><a href="/static/files/financial_statements/09062021/Finansov-otchet.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">Годишен индивидуален финансов отчет - част 1</span></a>
            <br><a href="/static/files/financial_statements/09062021/Finansov-otchet-II.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                    class="gm-table-link-text">Годишен индивидуален финансов отчет - част 2</span></a>

              <br><a href="/static/files/financial_statements/09062021/FULL-fin-report-first-part.pdf" target="_blank"
                     class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                      class="gm-table-link-text">Годишен консолидиран финансов отчет - част 1</span></a>

              <br><a href="/static/files/financial_statements/09062021/FULL-fin-report-second-part.pdf" target="_blank"
                     class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                      class="gm-table-link-text">Годишен консолидиран финансов отчет - част 2</span></a>

              <br><a href="/static/files/financial_statements/09062021/otchet-DVI-za-osa-perz-2021-za-2020.pdf" target="_blank"
                     class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                      class="gm-table-link-text">Отчет за връзки с инвеститорите</span></a>

              <br><a href="/static/files/financial_statements/09062021/poa-osa-2021.pdf" target="_blank"
                     class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                      class="gm-table-link-text">Пълномощно - образец</span></a>

              <br><a href="/static/files/financial_statements/09062021/pokana-osa-2021.pdf" target="_blank"
                     class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
                      class="gm-table-link-text">Покана за свикване на общо събрание</span></a>

          </td>
        </tr>

        <tr class="gm-table-row">
          <td class="gm-table-date">14.06.2019</td>
          <td class="gm-table-title">Общо събрание на акционерите на "Алкомет" АД, 14.06.2019 г.
            <br><a href="/static/files/general_meetings/14062019/protocol-no-eng.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол от Общото събрание на акционерите - 14.06.2019</span></a>
            <br><a href="/static/files/general_meetings/14062019/дневен-ред-ОСА.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Дневен ред ОСА</span></a>
            <br><a href="/static/files/general_meetings/14062019/отчет-за-дейността-на-дви.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Oтчет за дейността надви</span></a>
            <br><a href="/static/files/general_meetings/14062019/отчет-за-дейността-на-одитния-комитет.pdf"
                   target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Oтчет за дейността на одитния комитет</span></a>
            <br><a href="/static/files/general_meetings/14062019/годишен-доклад-за-дейността-2018.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен доклад за дейността 2018</span></a>
            <br><a
              href="/static/files/general_meetings/14062019/годишен-консолидиран-доклад-за-дейността-съгласно-приложение-N-10-на-наредба-N-2.pdf"
              target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен консолидиран доклад за дейността съгласно приложение N10 на наредба N2</span></a>
            <br><a href="/static/files/general_meetings/14062019/годишен-консолидиран-доклад-за-дейността.pdf"
                   target="_blank" class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Годишен консолидиран доклад за дейността</span></a>
            <br><a href="/static/files/general_meetings/14062019/доклад-за-дейността.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Доклад за дейността</span></a>
            <br><a href="/static/files/general_meetings/14062019/доклад-на-независимия-одитор.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Доклад на независимия одитор</span></a>
            <br><a href="/static/files/general_meetings/14062019/покана.pdf" target="_blank" class="gm-table-link"><span
              class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Покана</span></a>
            <br><a href="/static/files/general_meetings/14062019/пълномощно-образец.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Пълномощно образец</span></a>
            <br><a href="/static/files/general_meetings/14062019/становище-на-одитора.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Становище на одитора</span></a>
          </td>
        </tr>

        <tr class="gm-table-row">
          <td class="gm-table-date">22.02.2019</td>
          <td class="gm-table-title">Общо събрание на акционерите на "Алкомет" АД 22.02.2019 г.
            <br><a href="/static/files/general_meetings/dneven-red-22.02.2019.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Дневен ред</span></a>
            <br><a href="/static/files/general_meetings/model-poa-22.02.2019.pdf" target="_blank" class="gm-table-link"><span
              class="alcomet gm-table-download">u</span><span class="gm-table-link-text">Пълномощно за представляване на акционер в Общото събрание на акционерите на "Алкомет" АД</span></a>
            <br><a href="/static/files/general_meetings/pokana-22.02.2019.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Покана за свикване на извънредно Общо събрание</span></a>
            <br><a href="/static/files/general_meetings/protocol-ok-22.02.2019.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол от заседанието на Одитния комитет на "Алкомет" АД</span></a>
            <br><a href="/static/files/general_meetings/protokol-osa-22.02.2019.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол ОСА 22.02.2019</span></a>
          </td>
        </tr>
        <tr class="gm-table-row">
          <td class="gm-table-date">14.06.2018</td>
          <td class="gm-table-title">Общо събрание на акционерите на „Алкомет“ АД от 14.06.2018 г
            <br><a href="/static/files/general_meetings/protokol-osa-14.06.2018.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол ОСА, 14.06.2018 г.</span></a>
          </td>
        </tr>
        <tr class="gm-table-row">
          <td class="gm-table-date">12.06.2017</td>
          <td class="gm-table-title">Общо събрание на акционерите на „Алкомет“ АД от 12.06.2017 г.
            <br><a href="/static/files/general_meetings/protokol-osa-12.06.2017.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол ОСА, 12.06.2017</span></a>
          </td>
        </tr>
        <tr class="gm-table-row">
          <td class="gm-table-date">27.05.2016</td>
          <td class="gm-table-title">Общо събрание на акционерите на „Алкомет“ АД от 27.05.2016 г.
            <br><a href="/static/files/general_meetings/protokol-osa-27.05.2016.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол ОСА 27.05.2016</span></a>
          </td>
        </tr>
        <tr class="gm-table-row">
          <td class="gm-table-date">17.06.2015</td>
          <td class="gm-table-title">Общо събрание на акционерите на „Алкомет“ АД от 17.06.2015
            <br><a href="/static/files/general_meetings/protokol-osa-17.06.2015.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол ОСА 17.06.2015</span></a>
          </td>
        </tr>
        <tr class="gm-table-row">
          <td class="gm-table-date">20.06.2014</td>
          <td class="gm-table-title">Общо събрание на акционерите на „Алкомет“ АД от 20.06.2014
            <br><a href="/static/files/general_meetings/protokol-osa-20.06.2014.pdf" target="_blank"
                   class="gm-table-link"><span class="alcomet gm-table-download">u</span><span
              class="gm-table-link-text">Протокол ОСА 20.06.2014</span></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <app-share-button></app-share-button>
  </div>
</template>

<script>
  import ShareButton from "../shared/ShareButton";

  export default {
    components: {
      appShareButton: ShareButton
    }
  };
</script>

<style scoped>
  .investors-gm > p {
    font-size: 19px;
    line-height: 32px;
    margin: 15px auto;
    text-align: justify;
    width: 60%;
  }

  .gm-table-wrapper {
    border-radius: 6px;
    background-color: #edf2f4;
    margin: 30px auto 0;
    padding: 20px 10%;
    width: 80%;
  }

  .gm-table {
    border-collapse: collapse;
    margin: 0 auto;
    margin-left: -20px;
    width: calc(100% + 40px);
  }

  .gm-table tr,
  .gm-table td {
    border-bottom: 1px solid #becddb;
    padding-bottom: 21px;
    padding-top: 21px;
  }

  .gm-table-main-title {
    font-size: 19px;
    font-weight: 500;
    padding-left: 20px;
    vertical-align: middle;
    width: 85%;
  }

  .gm-table-title-icon {
    color: #8eaec8;
    font-size: 28px;
    margin-right: 10px;
  }

  .gm-table-add {
    color: rgba(0, 71, 133, 0.5);
    font-size: 12px;
    text-align: right;
    padding-right: 20px;
    width: 15%;
  }

  .gm-table-date {
    font-size: 14px;
    padding-left: 20px;
    padding-right: 20px;
    vertical-align: baseline;
  }

  .gm-table-title {
    font-size: 16px;
    font-weight: 500;
    width: 78%;
    vertical-align: baseline;
  }

  .gm-table-link {
    align-items: center;
    display: inline-flex;
    margin-top: 30px;
  }

  .gm-table-link-text {
    color: #0086ff;
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
  }

  .gm-table-download {
    font-size: 28px;
    margin-right: 14px;
  }

  @media screen and (max-width: 1000px) {
    .investors-gm > p {
      font-size: 16px;
      margin: 15px 0;
      padding: 0 30px;
      width: 100%;
    }

    .gm-table-wrapper {
      width: calc(100% - 60px);
    }

    .gm-table {
      margin-left: 0;
      width: 100%;
    }

    .gm-table-main-title,
    .gm-table-date {
      padding-left: 0;
    }

    .gm-table-main-title {
      font-size: 18px;
    }

    .gm-table-title,
    .gm-table-link-text {
      font-size: 14px;
    }

    .gm-table-link {
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 600px) {
    .gm-table-wrapper {
      padding: 0 20px 20px;
    }

    .gm-table-main-title {
      font-size: 14px;
    }

    .gm-table-title,
    .gm-table-link-text,
    .gm-table-date {
      font-size: 12px;
    }

    .gm-table-download {
      font-size: 22px;
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 440px) {
    .gm-table tr,
    .gm-table td {
      border: none;
    }

    .gm-table tr {
      display: flex;
      flex-direction: column;
    }

    .gm-table .gm-table-row {
      padding: 0;
    }

    .gm-table .gm-table-main-title {
      border-bottom: none;
    }

    .gm-table .gm-table-date {
      border-bottom: 1px solid #becddb;
      padding-right: 0;
      padding-bottom: 10px;
      text-align: left;
    }

    .gm-table .gm-table-title {
      padding-top: 10px;
      width: 100%;
    }

    .gm-table-link {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/investors/GeneralMeetings.vue